import './App.css';
import { PageLayout } from "./components/PageLayout";
import TransLogProvider from './contexts/TransLogContext';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./auth/authConfig";
import { setupAxiosInterceptor } from './libs/axiosInterceptor';
import { Outlet } from 'react-router-dom';

const msalInstance = new PublicClientApplication(msalConfig);

// Initialize axios interceptor
setupAxiosInterceptor(msalInstance);

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <TransLogProvider>
        <PageLayout>
          <Outlet />
        </PageLayout>
      </TransLogProvider>
    </MsalProvider>
  );
}

export default App;
